import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { SendService } from './send.service';

@Injectable({
    providedIn: 'root'
})
export class HomeService {
    SharingData = new Subject();

    constructor(private sendService: SendService) { }

    getBlocks(): Promise<any> {
        return this.sendService.getData('blocks', 24);
    }

    checkBlockType(value: any): Promise<any> {
        return this.sendService.getData('check', value);
    }

    checkBlocks(request: any, value: any): Promise<any> {
        return this.sendService.getData(request, value);
    }

    getTransactionsData(request: any, value: any): Promise<any> {
        return this.sendService.getTransactionsData(request, value);
    }

    getBTCTicket(): Promise<any> {
        return this.sendService.getSpecificURL('https://api.blockchain.com/v3/exchange/tickers');
    }

    getBTCTicketsData(page: any, limit: any): Promise<any> {
        return this.sendService.getSpecificURL(`${'https://cronjobs.filparty.com/api2?limit='}${limit}&page=${page}&tsym=usd`)
    }

    getGrapheDatas(coins: any, from: number, to: number): Promise<any> {
        return this.sendService.getSpecificURL(`https://cronjobs.filparty.com/graphs?coins=${coins}&fiat=USD&fromtime=${from}&totime=${to}`);
    }

    getFilPartyStat(): Promise<any> {
        return this.sendService.getTransactionsData('filparty/stats')
    }

    getDonateAction(data: boolean) {
        this.SharingData.next(data);
    }
}
